import PluginDatetime from './PluginDatetime';
import './style/index.less';

export default PluginDatetime;
